import { render, staticRenderFns } from "./Despesas.vue?vue&type=template&id=9e79cf52&scoped=true"
import script from "./Despesas.vue?vue&type=script&lang=js"
export * from "./Despesas.vue?vue&type=script&lang=js"
import style0 from "./Despesas.vue?vue&type=style&index=0&id=9e79cf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e79cf52",
  null
  
)

export default component.exports